import './Atencao.css';
import Button from '../../Button/button';
import BannerAtencaoHomePhone from '../../Banners/BannerAtencaoHomePhone/BannerAtencaoHomePhone.js'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import Loading from '../../Loading/Loading'

let button = document.querySelector(".continuar");
let spinnerButon = "continuar"

function Atencao() {
    const [isChecked, setIsChecked] = useState(true)
    const navigate = useNavigate();
    const [isShow, setShow] = useState(false);

    setTimeout(() => {
        //setShow(false);
    }, 1000);
    
    const nomeUsuario = sessionStorage.getItem("nomeUsuario")
    // console.log("nomeUsuario", nomeUsuario)

    return (
        <div className="home">
            {isShow && <Loading />}
            <BannerAtencaoHomePhone />
            <form
                className='container2'>
                <div className='form'>
                    <div className='titleform3'>
                        <h4>No momento não é possível realizar o Empréstimo com Débito na Conta de Luz.</h4>

                        <h1>Mas tudo bem <b>{nomeUsuario}</b>, pois o nosso compromisso é te ajudar a organizar sua vida financeira e realizar os seus sonhos.</h1>

                        <h1>Clique no botão abaixo para que um de nossos especialistas lhe apresente nossas outras soluções financeiras!</h1>
                    </div>
                    <div className='spaceform'></div>

                    <a href='https://euquerograna.com.br/antecipacao-do-fgts' className="btnContinuarLink"
                            cursor='pointer'>
                            OUTRAS OPORTUNIDADES
                        
                    </a>

                    <a href="https://euquerograna.com.br" className="btnVoltarLink"
                            cursor='pointer'>
                            FINALIZAR
                    </a>
                </div>
            </form>
     
        </div>
    );
}

export default Atencao;